// extracted by mini-css-extract-plugin
module.exports = {"inner":"Layout_inner__1xUOv","main":"Layout_main__C0z56","footer":"Layout_footer__cIVSd"};